import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import {
  Button,
  ButtonColorOption,
  ButtonVariantOption,
} from "@/components/Button";

interface DeletePlotDetailFileConfirmModalProps {
  open: boolean;
  fileName: string;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const DeletePlotDetailFileConfirmModal: React.FC<
  DeletePlotDetailFileConfirmModalProps
> = ({ open, fileName, isDeleting, onClose, onDelete }) => {
  const handleClose = (): void => {
    if (!isDeleting) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        handleClose();
      }}
      aria-labelledby="delete-file-dialog-title"
      aria-describedby="delete-file-dialog-description"
    >
      <DialogTitle id="delete-file-dialog-title">確認画面</DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-file-dialog-description">
          「{fileName}」を削除します。この操作は取り消せません。
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          label="キャンセル"
          onClick={handleClose}
          variant={ButtonVariantOption.Outlined}
          color={ButtonColorOption.Primary}
          disabled={isDeleting}
        />
        <Button
          label="削除する"
          onClick={onDelete}
          variant={ButtonVariantOption.Outlined}
          color={ButtonColorOption.Error}
          disabled={isDeleting}
        />
      </DialogActions>
    </Dialog>
  );
};
